/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Page_OfInputs */

const en_ccsl_export_page_of = /** @type {(inputs: Ccsl_Export_Page_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` of `)
};

const fr_ccsl_export_page_of = /** @type {(inputs: Ccsl_Export_Page_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` sur `)
};

const de_ccsl_export_page_of = /** @type {(inputs: Ccsl_Export_Page_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` von `)
};

const it_ccsl_export_page_of = /** @type {(inputs: Ccsl_Export_Page_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Di `)
};

const ru_ccsl_export_page_of = /** @type {(inputs: Ccsl_Export_Page_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` из `)
};

const es_ccsl_export_page_of = /** @type {(inputs: Ccsl_Export_Page_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` de `)
};

const zh_cn2_ccsl_export_page_of = /** @type {(inputs: Ccsl_Export_Page_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` 的 `)
};

const ja_ccsl_export_page_of = /** @type {(inputs: Ccsl_Export_Page_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` の `)
};

const hi_ccsl_export_page_of = /** @type {(inputs: Ccsl_Export_Page_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` का `)
};

const pt_pt2_ccsl_export_page_of = /** @type {(inputs: Ccsl_Export_Page_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` de `)
};

/**
* | output |
* | --- |
* | "of" |
*
* @param {Ccsl_Export_Page_OfInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_page_of = /** @type {((inputs?: Ccsl_Export_Page_OfInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Page_OfInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_page_of(inputs)
	if (locale === "de") return de_ccsl_export_page_of(inputs)
	if (locale === "it") return it_ccsl_export_page_of(inputs)
	if (locale === "ru") return ru_ccsl_export_page_of(inputs)
	if (locale === "es") return es_ccsl_export_page_of(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_page_of(inputs)
	if (locale === "ja") return ja_ccsl_export_page_of(inputs)
	if (locale === "hi") return hi_ccsl_export_page_of(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_page_of(inputs)
	return en_ccsl_export_page_of(inputs)
});